import config from '@project/config';

const contactUsBaseUrl = `${config.apiUrl}/general_informations`;

export default {
  postContactUsUrl: () => `${contactUsBaseUrl}/contact_us`,
};
